export const authenticationZh = {
  menu: '目录',
  sectionMaterial: '内容',
  sectionAssessment: '测评',
  sectionUpcoming: '持续更新',
  open: '展开',
  close: '关闭',
  courseIntroduction: '课程简介',
  finished: '已完成',
  authenticationCenter: '认证中心',
  download: '下载',
  share: '分享',
  taskCard: '任务卡',
  get: '获得',
  shareCertificate: '分享证书',
  tips: '打开手机微信扫描二维码，\n分享证书到微信/朋友圈吧～',
  ApplySchool: {
    applySchool: '申请新增学校',
    yourName: '你的名字：',
    ContactInformation: '联系方式：',
    yourSchool: '你的学校：',
    region: '行政区域：',
    remark: '备注：',
    description: '说明：组委会收到申请后，会有专人与你联系，协助完成报名。',
    submit: '提交'
  }
}

export const authenticationEn = {
  menu: 'Menu',
  sectionMaterial: 'Content',
  sectionAssessment: 'Assessment',
  sectionUpcoming: 'Coming soon',
  open: 'Open',
  close: 'Close',
  courseIntroduction: 'Course Introduction',
  finished: 'Finished',
  authenticationCenter: 'Authentication Center',
  download: 'download',
  share: 'share',
  taskCard: 'Task card',
  get: 'get',
  shareCertificate: 'Share Certificate',
  tips: 'Open wechat to scan QR code,\n Share your certificate with wechat / circle of friends ~',
  ApplySchool: {
    applySchool: 'Apply for a new school',
    yourName: 'Your name:',
    ContactInformation: 'Contact information:',
    yourSchool: 'Your school:',
    region: 'Administrative region:',
    remark: 'remark:',
    description: 'Description: The Organizing committee will contact you to help complete the registration after receiving the application.',
    submit: 'Submit'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/authentication/index.js